"use client";

import React from "react";
import Image from "next/image";

const Footer = () => (
  <footer className="bg-[#050505] py-16 border-t border-white/5 text-center text-gray-600 text-sm">
    <div className="mb-6 flex items-center justify-center gap-2">
      <Image
        src="/brand/logo.svg"
        alt="SmartDwara Logo"
        width={32}
        height={32}
        className="w-8 h-8 rounded-xl" // <--- Adds the curve
      />
      <div className="flex items-center">
        <span className="text-white font-clash font-semibold text-2xl tracking-tight group-hover:text-gray-200 transition-colors">
          Smart
        </span>
        <span className="font-clash font-bold text-2xl tracking-tight text-transparent bg-clip-text bg-linear-to-r from-orange-500 to-amber-500">
          Dwara
        </span>
      </div>
    </div>
    <p className="font-medium">
      © 2026 SmartDwara Inc. Made with ❤️ in Mumbai.
    </p>
  </footer>
);

export default Footer;
